import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  shape, string, useDataModel, params, arrayOf, bool
} from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { isEtchVisNavOnPLP } from '../utils/composable/composableUtils';
import { ProductCategoryVisnav } from '../components/ProductCategoryVisnav';

const ProductCategoryVisnavComposable = (props) => {
  const { viewVizNavFilters, customContainerClasses, customHybridClasses, experienceType } = props;
  const { customContext, customer } = useContext(ExperienceContext);

  const {
    isBrandPage,
    isHybridLayout,
    variables = {}
  } = customContext || {};
  const isB2B = customer?.type === 'b2b';

  const defaultOptions = {
    variables,
    ssr: true,
    skip: !variables.navParam && !variables.keyword,
  };
  const {
    data: searchModelData
  } = useDataModel('searchModel', defaultOptions);

  const isEtchVisNavInPLP = isEtchVisNavOnPLP(searchModelData, isB2B, experienceType);
  const hasVisnavData = (searchModelData?.searchModel?.relatedResults?.visualNavs ?? []).length > 0;

  if (isEtchVisNavInPLP && !viewVizNavFilters && isBrandPage && !hasVisnavData) {
    return null;
  }

  return (
    <div
      className={isHybridLayout && customHybridClasses ? customHybridClasses : customContainerClasses}
    >
      <ProductCategoryVisnav
        data={searchModelData}
      />
    </div>
  );
};

ProductCategoryVisnavComposable.displayName = 'ProductCategoryVisnavComposable';

ProductCategoryVisnavComposable.propTypes = {
  viewVizNavFilters: PropTypes.bool,
  customContainerClasses: PropTypes.string,
  customHybridClasses: PropTypes.string,
  experienceType: PropTypes.string
};

ProductCategoryVisnavComposable.defaultProps = {
  viewVizNavFilters: false,
  customContainerClasses: '',
  customHybridClasses: '',
  experienceType: ''
};

ProductCategoryVisnavComposable.dataModel = {
  searchModel: params({ keyword: string(), navParam: string() }).shape({
    metadata: shape({
      contentType: string(),
      hasPLPBanner: bool(),
    }),
    partialTemplates: arrayOf(string()),
    relatedResults: shape({
      visualNavs: arrayOf(
        shape({
          label: string(),
          imageId: string(),
          webUrl: string(),
          categoryId: string(),
          imageURL: string(),
        })
      ),
      visualNavContainsEvents: bool(),
    }),
    searchReport: shape({
      keyword: string(),
    }),
    dimensions: arrayOf(
      shape({
        label: string(),
        refinements: arrayOf(
          shape({
            url: string(),
            refinementKey: string(),
          })
        ),
      })
    ),
  }),
};

export { ProductCategoryVisnavComposable };